'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dName$0024 from "./presto.types$-Rule-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_RulesTable$$anon$3() {
}
export { $c_Lpresto_RulesTable$$anon$3 as $c_Lpresto_RulesTable$$anon$3 };
$p = $c_Lpresto_RulesTable$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RulesTable$$anon$3;
/** @constructor */
function $h_Lpresto_RulesTable$$anon$3() {
}
export { $h_Lpresto_RulesTable$$anon$3 as $h_Lpresto_RulesTable$$anon$3 };
$h_Lpresto_RulesTable$$anon$3.prototype = $p;
$p.aR = (function(item) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, item.n2, $j_presto$002etypes$0024$002dRule$002dName$0024.$m_Lpresto_types$RuleName$().csm());
});
var $d_Lpresto_RulesTable$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RulesTable$$anon$3, "presto.RulesTable$$anon$3", ({
  Qm: 1,
  A: 1
}));
export { $d_Lpresto_RulesTable$$anon$3 as $d_Lpresto_RulesTable$$anon$3 };
//# sourceMappingURL=presto.-Rules-Table$$anon$3.js.map
